import React, { Component } from "react";
import Contentify from "../../content/Contentify";
import { connect } from "react-redux";
import styles from "../../assets/css/modules/claims/appointment-details.css";
import Store from "../../content/Store";
import { Paths } from "../../constants/UrlConstants";
import { withRouter, Link } from "react-router-dom";
import ShadowedContainer from "../shared/containers/ShadowedContainer";
import Article from "../shared/Article";
import Button from "../shared/buttons/Button";
import Content from "../../content/Content";
import HelpSection from "../shared/HelpSection";
import PromoImageCard from "../shared/PromoImageCard";
import PromoContainer from "../shared/containers/PromoContainer";
import SummaryDetail from "../shared/groups/SummaryDetail";
import SummaryDetailRow from "../shared/groups/SummaryDetailRow";
import printStyle from "../../assets/css/modules/print.css";

export const mapStateToAppointmentDetails = (state, props) => {
  let appointmentDetails =
    state &&
    state.claimsReducer &&
    state.claimsReducer.selectedPolicy.appointments &&
    props &&
    props.location &&
    props.location.state &&
    props.location.state.index !== undefined &&
    state.claimsReducer.selectedPolicy.appointments[props.location.state.index];

  return {
    appointmentDetails
  };
};

export class AppointmentDetails extends Component {
  static content = Store.Appointments;
  componentDidMount() {
    if (!this.props.appointmentDetails) {
      this.props.history.replace(Paths.Appointments);
    }
  }
  render() {
    return (
      <div className={"postLogin " + styles.appointmentDetails}>
        <div className={"container " + printStyle.noprint}>
          <div id="back-button" className="back-button">
            <Link to={Paths.Appointments}>
              <span className="mr-2 left-arrow-back">←</span>{" "}
              {this.props.content.AppointmentsBackButtonLabel}
            </Link>
          </div>
        </div>
        <ShadowedContainer>
          <div className="row">
            <div className={"col-lg-8 " + styles.articleDescription}>
              <Article
                header={this.props.content.AppointmentDetails.Header}
                body={this.props.content.AppointmentDetails.Body}
              />
              <div className={styles.calendarSection}>
                <div className={styles.icon + " " + styles.calendarIcon}>
                  <i className="icon-functional-calendar-outline" />
                </div>
                <p className={styles.calendarDescription}>
                  {this.props.content.AppointmentDetails.AppointmentDescription}
                </p>
              </div>
            </div>
            <div
              className={
                "text-right col-lg-4 " +
                styles.printTop +
                " " +
                printStyle.noprint
              }
            >
              <div className={styles.icon}>
                <i className="icon-functional-print" />
              </div>
              <p>
                {this.props.content.AppointmentDetails.PrintDetailDescription}
              </p>
              <Button
                label={this.props.content.AppointmentDetails.PrintDetailsButton}
                buttonType="primaryOrangeButton"
                onClick={() => window.print()}
              />
            </div>
          </div>
          {this.props.appointmentDetails ? (
            <React.Fragment>
              <div className={"row mt-4 " + styles.appointmentDetailsSection}>
                <div className="col-lg-6">
                  <SummaryDetail>
                    <SummaryDetailRow
                      title={
                        this.props.content.AppointmentDetails.AppointmentType
                      }
                      value={this.props.appointmentDetails.TreatmentCategory}
                    />
                    <SummaryDetailRow
                      title={this.props.content.AppointmentDetails.Date}
                      value={this.props.appointmentDetails.AppointmentDate}
                    />

                    <SummaryDetailRow
                      title={this.props.content.AppointmentDetails.Time}
                      value={this.props.appointmentDetails.AppointmentTime}
                    />

                    <SummaryDetailRow
                      title={this.props.content.AppointmentDetails.ClaimNumber}
                      value={this.props.appointmentDetails.ClaimNumber}
                    />

                    <SummaryDetailRow
                      title={this.props.content.AppointmentDetails.Specialist}
                      value={this.props.appointmentDetails.SpecialistName}
                    />

                    {this.props.appointmentDetails.HospitalName && (
                      <SummaryDetailRow
                        title={
                          this.props.content.AppointmentDetails.HospitalName
                        }
                        value={this.props.appointmentDetails.HospitalName}
                      />
                    )}

                    <SummaryDetailRow
                      title={
                        this.props.content.AppointmentDetails.HospitalAddress
                      }
                      value={this.props.appointmentDetails.HospitalAddress}
                      customValueStyle={styles.hospitalAddress}
                    />

                    <SummaryDetailRow
                      title={
                        this.props.content.AppointmentDetails
                          .HospitalTelephoneNumber
                      }
                      value={
                        this.props.appointmentDetails
                          .HospitalTelephoneLineNumber
                      }
                    />

                    <SummaryDetailRow
                      title={
                        this.props.content.AppointmentDetails.BookingRefNumber
                      }
                      value={
                        this.props.appointmentDetails.BookingReferenceNumber
                      }
                    />
                    {this.props.appointmentDetails.AdditionalInformation ? (
                      <SummaryDetailRow
                        title={
                          this.props.content.AppointmentDetails
                            .AdditionalInformation
                        }
                        value={
                          this.props.appointmentDetails.AdditionalInformation
                        }
                      />
                    ) : null}
                  </SummaryDetail>
                </div>
                <div className={"col-lg-6"}>
                  <div className={styles.afterAppointmentSection}>
                    <h2>
                      {this.props.content.AppointmentDetails.WhatToTakeWithYou}
                    </h2>
                    <p>
                      {
                        this.props.content.AppointmentDetails
                          .WhatToTakeDescription
                      }
                    </p>
                    <ul>
                      <li>
                        <span className={styles.iconCheckBlue}>
                          <i className="icon-check-blue" />
                        </span>
                        {this.props.content.AppointmentDetails.YourClaimNumber +
                          this.props.appointmentDetails.ClaimNumber}{" "}
                      </li>
                      <li>
                        <span className={styles.iconCheckBlue}>
                          <i className="icon-check-blue" />
                        </span>
                        {this.props.content.AppointmentDetails.GPLetter}
                      </li>
                      <li>
                        <span className={styles.iconCheckBlue}>
                          <i className="icon-check-blue" />
                        </span>
                        {this.props.content.AppointmentDetails.DebitCard}
                      </li>
                    </ul>
                    <div className={styles.afterDetailsBorder} />
                    <h2>
                      {
                        this.props.content.AppointmentDetails
                          .AfterAppointHeading
                      }
                    </h2>
                    <p>
                      {
                        this.props.content.AppointmentDetails
                          .AfterAppointDescription
                      }
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={
                  "text-right col-lg-4 " +
                  styles.printBottom +
                  " " +
                  printStyle.noprint
                }
              >
                <div className={styles.icon}>
                  <i className="icon-functional-print" />
                </div>
                <p>
                  {this.props.content.AppointmentDetails.PrintDetailDescription}
                </p>
                <Button
                  label={
                    this.props.content.AppointmentDetails.PrintDetailsButton
                  }
                  buttonType="primaryOrangeButton"
                  onClick={() => window.print()}
                />
              </div>
              <Content
                name={this.props.content.AppointmentDetails.HelpSetAnswer}
                params={{
                  Specialist: this.props.appointmentDetails.SpecialistName,
                  ContactNumberForCancellation: this.props.appointmentDetails
                    .ContactNumberForCancellation
                }}
              >
                {(answer) => (
                  <HelpSection
                    HeadingLinkTo={this.props.content.HelpSection.HeadingLinkTo}
                    HeadingLinkText={
                      this.props.content.HelpSection.HeadingLinkText
                    }
                    MoreHelpLinkTo={
                      this.props.content.HelpSection.MoreHelpLinkTo
                    }
                    MoreHelpLinkText={
                      this.props.content.HelpSection.MoreHelpLinkText
                    }
                    HelpSet={[
                      {
                        Question: this.props.content.AppointmentDetails
                          .HelpSetQuestion,
                        Answer: answer
                      }
                    ]}
                  />
                )}
              </Content>
            </React.Fragment>
          ) : null}
        </ShadowedContainer>

        <div className={printStyle.noprint}>
          <PromoContainer>
            <PromoImageCard
              ImgSrc={Store.Home.Cards.AskMedExpert.IconSrc}
              ImgSrcMobile={Store.Home.Cards.AskMedExpert.IconSrcMobile}
              Heading={Store.Home.Cards.AskMedExpert.Heading}
              Description={Store.Home.Cards.AskMedExpert.Description}
              LinkText={Store.Home.Cards.AskMedExpert.LinkText}
              LinkTo={Store.Home.Cards.AskMedExpert.LinkTo}
              LeftImage
            />
          </PromoContainer>
        </div>
      </div>
    );
  }
}
export default withRouter(
  connect(mapStateToAppointmentDetails, null)(Contentify(AppointmentDetails))
);
